import { isPC } from "@modules/util/device"
import { debounce } from "lodash-es"
import {
    soladsBeforePaginationHtmlMobile,
    soladsBeforePaginationHtmlPc,
    soladsTemplateDataId,
} from "../solads/templates"
import { advertCardsContainerElement } from "./dom"

export function rerenderSoladsBeforePagination() {
    if (userData.hasAdFree || userData.isAgeVerified) {
        return
    }
    // remove existing solads element
    const soladsElement = document.querySelector(`[data-solads-id="${soladsTemplateDataId}"]`)
    if (soladsElement) {
        soladsElement.remove()
    }

    const html = isPC() ? soladsBeforePaginationHtmlPc : soladsBeforePaginationHtmlMobile
    advertCardsContainerElement()?.insertAdjacentHTML("afterend", html)
}

if (!userData.hasAdFree && !userData.isAgeVerified) {
    window.addEventListener(
        "orientationchange",
        debounce(() => {
            rerenderSoladsBeforePagination()
        }, 200),
    )
    window.addEventListener(
        "resize",
        debounce(() => {
            rerenderSoladsBeforePagination()
        }, 200),
    )
    rerenderSoladsBeforePagination()
}
